module.exports = __webpack_public_path__ + "static/img/fi.2873b463.svg";